export default __webpack_public_path__ + "static/media/Prophecy_3x2_En.1fe03b10.webp";